import React, { useState } from 'react';
import { removeTokenFromCookies} from "../../utils/jwtToke";
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';

const Header = ({showNav,setShowNav}) => {
    const [dropDownStatus,setDropDownStatus] = useState(false)
    const navigate = useNavigate()
    var getInfo = localStorage.getItem('User') || "{}";
    let admin = JSON.parse(getInfo);
    function SigneOut(){
      Swal.fire({
        title: "Are you sure?",
        text: "You want to Sign out!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes!"
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire({
            title: "sign out!",
            text: "Signe out sucessfully.",
            icon: "success"
          });
          removeTokenFromCookies();
          navigate(0)
        }
        setDropDownStatus(false)
      }).catch(()=>setDropDownStatus(false))
      
    }
  return (
    <>
        <div className="sticky inset-x-0 top-0 z-30 flex items-center justify-between px-4 py-4 border-b border-gray-300 bg-primary-600 bg-opacity-90 backdrop-blur-md sm:px-6 lg:px-8">
          <div className="flex items-center justify-between flex-1 min-w-0">
            <p className="hidden text-xl leading-6 text-white sm:truncate lg:block">
              Online Education Administration Portal
            </p>

            <button type="button"  onClick={()=>setShowNav(true)}  className="inline-flex items-center justify-center w-10 h-10 -ml-2 text-white transition-all bg-transparent rounded-lg hover:bg-black hover:bg-opacity-30 lg:hidden focus:outline-none focus:ring-1 focus:ring-offset-primary-600 focus:ring-offset-1 focus:ring-white" aria-controls="mobile-menu" aria-expanded="false" data-toggle="drawer" data-target="#drawerLeft">
              <span className="sr-only">Open main menu</span>
              <svg className="w-6 h-6" stroke="currentColor" viewBox="0 0 256 256">
                <line x1="40" y1="128" x2="216" y2="128" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="20"></line>
                <line x1="40" y1="64" x2="216" y2="64" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="20"></line>
                <line x1="40" y1="192" x2="216" y2="192" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="20"></line>
              </svg>
            </button>

            <h1 className="ml-5 mr-auto text-xl font-medium leading-6 text-white lg:hidden">
              Course Settings
            </h1>
          </div>

          <div className="flex items-center space-x-6 sm:ml-4">
            <div className="dropdown">
              <button type="button" onClick={()=>setDropDownStatus(!dropDownStatus)} className="flex space-x-1 items-center text-white rounded-lg focus:outline-none focus:ring-1 focus:ring-offset-primary-600 focus:ring-offset-1 focus:ring-white dropdown-toggle" data-toggle="dropdown" id="dropdownMenuButton" aria-haspopup="true" aria-expanded="true">
                <div className='flex items-center'>
                  <div className='w-6 h-6 hidden sm:flex'>
                    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="12" cy="7" r="4" stroke="#fff" strokeWidth="2" strokeLinecap="round"/>
                    <path d="M5.33788 18.3206C5.99897 15.5269 8.77173 14 11.6426 14H12.3574C15.2283 14 18.001 15.5269 18.6621 18.3206C18.79 18.8611 18.8917 19.4268 18.9489 20.0016C19.0036 20.5512 18.5523 21 18 21H6C5.44772 21 4.99642 20.5512 5.0511 20.0016C5.1083 19.4268 5.20997 18.8611 5.33788 18.3206Z" stroke="#fff" strokeWidth="2" strokeLinecap="round"/>
                    </svg>
                  </div>
                  <span className="hidden ml-2 font-medium sm:flex">
                    {admin.firstname + " " + admin.lastname}
                  </span>
                </div>
                <svg className="w-6 h-6" stroke="currentColor" viewBox="0 0 256 256">
                <circle cx="128.00098" cy="128.00195" r="44" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="20"></circle>
                <path d="M197.40919,80.65057a83.91174,83.91174,0,0,1,6.28744,10.91L229.6429,105.964a103.88962,103.88962,0,0,1,.03183,44.05764L203.714,164.433a83.912,83.912,0,0,1-6.30466,10.90011l.49943,29.67182a103.88959,103.88959,0,0,1-38.13912,22.05638l-25.46093-15.27692a83.91075,83.91075,0,0,1-12.5921-.01L96.26983,227.04288a103.88979,103.88979,0,0,1-38.17095-22.00126l.49974-29.68828a83.91174,83.91174,0,0,1-6.28744-10.91005L26.36491,150.0399a103.88962,103.88962,0,0,1-.03182-44.05764L52.29376,91.5709a83.9124,83.9124,0,0,1,6.30466-10.9001L58.099,50.999A103.88973,103.88973,0,0,1,96.23811,28.94259l25.46094,15.27693a83.91061,83.91061,0,0,1,12.59209.00995L159.738,28.961a103.88951,103.88951,0,0,1,38.171,22.00126Z" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="20"></path>
                </svg>
              </button>

              <div className={`dropdown-menu ${dropDownStatus? "active" : ""}`} role="menu" aria-orientation="vertical" aria-labelledby="menu-button" tabIndex="-1">
                <div className="divide-y divide-gray-100">
                  <div className="py-1" role="none">
                    <div title="" className="dropdown-item" role="menuitem" tabIndex="-1">
                      Account settings
                    </div>
                  </div>
                  <div className="py-1" role="none">
                    <form method="POST" action="#" role="none">
                      <button type="button" onClick={SigneOut} className="w-full dropdown-item" role="menuitem" tabIndex="-1" id="menu-item-3">
                        Sign out
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
    </>
  )
}

export default Header